import { Input } from 'antd'
import React from 'react'

const InputField = ({
    handleInputChange,
    label  = "",
    name  = "",
    type = "text",
    placeholder = "",
    important = "false",
    formData = {},
    errors,
    disabled =false
}) => {
  return (
      <div
      
          style={{
          
                marginTop :"10px"
      }}
      >
          <label>{label}
              {important && <span style={{
                  color: 'red'
              }}> *</span>}
           
              <Input
                  style={{
                      width: "100%",
                  }}
                  name={name}
                  type={type}
                  placeholder={placeholder}
                  value={formData[name] || ""}
                  onChange={handleInputChange}
                  min={0} 
                  disabled={disabled}
              />
             
              {
                  errors && errors[name] && <div
                      style={{
                      color : "red"
                  }}
                  >
                      {
                          errors[name]
                      }</div>
}

          </label>
          
    </div>
  )
}

export default InputField